<!-- Copy of app/javascript/components/activities/ActivitiesBlock.vue. Stripped down to just use the necessary
components for the getting_started review_screenshots substep. -->

<template>
  <div class="activity-screenshot">
    <a
      href="#"
      target="_blank"
      class="unclickable"
    >
      <div
        v-tooltip="{ placement: 'top', html: true }"
        class="label-project-name"
        :title="projectNamesTooltip"
      >
        {{ allProjectNames }}
      </div>
    </a>
    <a
      href=""
      class="unclickable"
      target="_blank"
    >
      <div
        v-if="hasTaskSummaries"
        v-tooltip="{ placement: 'top', html: true }"
        class="task-name"
        :title="taskSummariesTooltip"
      >
        {{ allTaskSummaries }}
      </div>
      <div
        v-else
        class="task-name text-superlight"
      >No to-dos</div>
    </a>
    <div class="top-shot-body">
      <div
        class="shot-body fs-exclude"
        :class="shotBodyClass"
        @click="showGalleryOrSelect"
      >
        <template v-if="hasScreens">
          <div class="screenshot-activity-overlay">
            <a
              v-if="shouldShowScreenshots"
              class="btn btn-sm btn-outline-default slot-view overlay-content shot no-action"
              @click="toggleScreenshotsDialog"
            >
              View screens
            </a>
          </div>
          <div
            v-if="shouldShowScreenshots"
            class="state_shot"
          >
            <img
              class="no-action"
              :src="firstScreenshot.thumb_url"
            />
          </div>
          <div
            v-else
            class="state_shot no_screenshot"
          >
            <div class="state-shot-wrapper">
              <i class="hi hi-screenshot"></i>
              <div>
                <template v-if="hasScreens && !screensDeleted">
                  Screenshot hidden
                </template>
                <template v-else>
                  Screenshot deleted
                </template>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="state_shot"
            :class="noShotCssClass"
          >
            <div class="state-shot-wrapper">
              <i
                class="hi"
                :class="noShotIcon"
              ></i>
              <div>
                <p>No screenshot</p>
                <p v-if="noScreenshotReason">{{ noScreenshotReason }}</p>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div
        v-if="hasScreens && !screensDeleted"
        class="screen-count-pill"
      >
        {{ screenCount }} {{ $filters.pluralize(screenCount, 'screen', 'screens') }}
      </div>
      <div class="meta">
        <div class="meta-head">
          <div class="meta-interval">{{ activity.slot_span }}</div>
          <div class="meta-icons">
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 activity">
            <template v-if="showProgressBar">
              <ActivitiesProgressBar
                v-tooltip="{ html: true, placement: 'bottom' }"
                :activity="activity"
                :title="progressBarTooltip"
              />
            </template>
            <template v-else>
              <div class="progress no-data"></div>
            </template>
            {{ activityLabel }}
          </div>
        </div>
      </div>
    </div>

    <AppDialog
      :show="showScreenhotsDialog"
      title="Screenshots"
      class="getting-started-review-screenshots-dialog"
      append-to-body
      size="large"
      @close="toggleScreenshotsDialog"
    >
      <div class="carousel">
        <a
          class="arrow left-arrow"
          @click="prevScreenshot"
        >
          <i class="hi-left hi-24"></i>
        </a>
        <img :src="availableScreenshots[currentScreenshotIndex].original_url" />
        <a
          class="arrow right-arrow"
          @click="nextScreenshot"
        >
          <i class="hi-right hi-24"></i>
        </a>
      </div>
      <div class="description">
        {{ availableScreenshots[currentScreenshotIndex].caption }}
      </div>
    </AppDialog>
  </div>
</template>

<script>
import ActivitiesProgressBar from '~/components/activities/ActivitiesProgressBar.vue';
import { FAKE_DATA_IMAGE_URLS } from '~/rails_assets';
import { sample } from 'lodash-es';

export default {
  name: 'ActivitiesBlock',
  components: {
    ActivitiesProgressBar,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentScreenshotIndex: 0,
      showScreenhotsDialog: false,
    }
  },
  computed: {
    selectedTimeSlots() {
      return []
    },
    proxyUser() {
      return false
    },
    screenshotSettingEnabled() {
      return true
    },
    fakeData() {
      return {
        me: false,
        required: false,
        show: true,
        team: true,
      }
    },
    projectNames() {
      return this.activity.project_names || [];
    },
    projectNamesTooltip() {
      const projectNames = this.projectNames.map((projectName) => HubstaffUtils.escapeHTML(projectName));

      return projectNames.join('<br/>');
    },
    allProjectNames() {
      return this.projectNames.join(', ');
    },
    taskSummaries() {
      return (this.activity && this.activity.task_summaries && this.activity.task_summaries.split(', ')) || [];
    },
    taskSummariesTooltip() {
      const taskSummaries = this.taskSummaries.map((taskSummary) => HubstaffUtils.escapeHTML(taskSummary));

      return taskSummaries.join('<br/>');
    },
    allTaskSummaries() {
      return this.taskSummaries && this.taskSummaries.join(', ');
    },
    hasTaskSummaries() {
      return this.taskSummaries && this.taskSummaries.length > 0;
    },
    hasScreens() {
      return !this.activity.idle_time && typeof this.screenCount === 'number' ? this.screenCount > 0 : false;
    },
    screenshots() {
      return this.activity.screens.filter((screen) => !!screen.thumb_url);
    },
    availableScreenshots() {
      return this.screenshots.filter((screen) => !screen.deleted);
    },
    hasScreenshots() {
      return !this.activity.idle_time && (this.availableScreenshots.length || this.fakeDataRequired);
    },
    firstScreenshot() {
      if (this.fakeDataRequired) {
        return sample(FAKE_DATA_IMAGE_URLS);
      }

      return this.hasScreenshots ? this.screenshots[0] : null;
    },
    shouldShowScreenshots() {
      return this.hasScreenshots && !this.proxyUser && !this.screensDeleted;
    },
    screensDeleted() {
      return this.activity && this.activity.screens.filter((screen) => !screen.deleted).length === 0;
    },
    screenCount() {
      return this.activity && this.activity.screens && this.activity.screens.length;
    },
    isManualTime() {
      return this.activity.manual_time;
    },
    isMobileTime() {
      return this.activity.mobile_time;
    },
    isBrowserTime() {
      return this.activity.browser_time;
    },
    isWebTime() {
      return this.activity.web_time;
    },
    isApiTime() {
      return this.activity.api_time;
    },
    isResumedTime() {
      return this.activity.resumed_time;
    },
    isIdleTime() {
      return this.activity.idle_time;
    },
    wantsInput() {
      return this.activity.wants_input;
    },
    supportsInput() {
      return this.activity.supports_input;
    },
    noScreenshotReason() {
      if (this.isManualTime) {
        return 'Manual entry';
      } if (this.isMobileTime) {
        return 'Mobile app used';
      } if (this.isBrowserTime) {
        return 'Browser ext. used';
      } if (this.isWebTime) {
        return 'Web timer used';
      } if (this.isApiTime) {
        return 'Time added via API';
      } if (this.isResumedTime) {
        return 'App catch up';
      } if (this.isIdleTime) {
        return 'Idle time';
      }

      return null;
    },
    noShotCssClass() {
      let cssClass = 'no_screenshot';

      if (this.isMobileTime) {
        cssClass = 'mobile_time';
      } else if (this.isBrowserTime || this.isWebTime || this.isApiTime) {
        cssClass = 'browser_time';
      } else if (this.isIdleTime) {
        cssClass = 'idle_time';
      }

      return cssClass;
    },
    noShotIcon() {
      let iconClass = 'hi-screenshot';

      if (this.isManualTime) {
        iconClass = 'hi-manual-time';
      } else if (this.isMobileTime) {
        iconClass = 'hi-mobile-time';
      } else if (this.isBrowserTime || this.isWebTime || this.isApiTime) {
        iconClass = 'hi-browser-time';
      } else if (this.isIdleTime) {
        iconClass = 'hi-idle';
      }

      return iconClass;
    },
    formattedOverall() {
      return this.activity.overall + '%';
    },
    formattedKeyboard() {
      return this.activity.keyboard + '%';
    },
    formattedMouse() {
      return this.activity.mouse + '%';
    },
    activityLabel() {
      const tracked = this.activity.tracked;
      const formattedTime = tracked < 60 ? `${tracked} seconds` : `${Math.floor(tracked / 60)} minutes`;

      if (this.showProgressBar) {
        return `${this.formattedOverall} of ${formattedTime}`;
      }

      return formattedTime;
    },
    showProgressBar() {
      return this.wantsInput && this.supportsInput;
    },
    progressBarTooltip() {
      let tooltip;

      if (this.isManualTime) {
        tooltip = 'Manual time';
      } else if (this.showProgressBar) {
        tooltip = `Overall: ${this.formattedOverall}<br/>Mouse: ${this.formattedMouse} Keyboard: ${this.formattedKeyboard}`;
      }

      return tooltip;
    },
    fakeDataRequired() {
      return this.fakeData.required;
    },
    shotBodyClass() {
      return this.fakeDataRequired ? 'no-actions no-screenshot' : '';
    },
    timeSlot() {
      return this.activity && this.activity.time_slot;
    },
    isSelected() {
      return this.selectedTimeSlots.includes(this.timeSlot);
    },

  },
  methods: {
    showGalleryOrSelect() {
      return false
    },
    toggleScreenshotsDialog() {
      this.showScreenhotsDialog = !this.showScreenhotsDialog;
    },
    nextScreenshot() {
      if (this.currentScreenshotIndex < this.availableScreenshots.length - 1) {
        this.currentScreenshotIndex++;
      } else {
        this.currentScreenshotIndex = 0;
      }
    },
    prevScreenshot() {
      if (this.currentScreenshotIndex > 0) {
        this.currentScreenshotIndex--;
      } else {
        this.currentScreenshotIndex = this.availableScreenshots.length - 1;
      }
    },
  },
};
</script>
